import React, { useState } from 'react';
import { useCurrency } from '../../contexts/CurrencyContext';
import '../../styles/CurrencySelectorMobile.css';

const CurrencySelectorMobile = ({ onClose }) => {
  const { selectedCurrency, changeCurrency, getCurrencySymbol, getCurrencyName, CURRENCIES } = useCurrency();
  const [isExpanded, setIsExpanded] = useState(false);

  const handleCurrencySelect = (code) => {
    changeCurrency(code);
    setIsExpanded(false);
    if (onClose) onClose();
  };

  const handleToggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const currencyCodes = Object.keys(CURRENCIES);
  const selectedCurrencyData = CURRENCIES[selectedCurrency];

  return (
    <div className="currency-selector-mobile">
      <h3 className="currency-selector-mobile__title">Выберите валюту</h3>
      
      {/* Collapsed view - shows only selected currency */}
      {!isExpanded && (
        <button
          className="currency-selector-mobile__current"
          onClick={handleToggleExpand}
          aria-label="Развернуть список валют"
        >
          <span className="currency-selector-mobile__symbol">{selectedCurrencyData.symbol}</span>
          <span className="currency-selector-mobile__name">{selectedCurrencyData.name}</span>
          <span className="currency-selector-mobile__code">({selectedCurrency})</span>
          <svg 
            className="currency-selector-mobile__expand-icon" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="2"
          >
            <path d="M6 9l6 6 6-6"/>
          </svg>
        </button>
      )}

      {/* Expanded view - shows all currencies */}
      {isExpanded && (
        <div className="currency-selector-mobile__expanded">
          <button
            className="currency-selector-mobile__collapse"
            onClick={handleToggleExpand}
            aria-label="Свернуть список валют"
          >
            <svg 
              className="currency-selector-mobile__collapse-icon" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2"
            >
              <path d="M18 15l-6-6-6 6"/>
            </svg>
            <span>Свернуть</span>
          </button>
          <div className="currency-selector-mobile__list">
            {currencyCodes.map(code => {
              const currency = CURRENCIES[code];
              return (
                <button
                  key={code}
                  className={`currency-selector-mobile__option ${
                    selectedCurrency === code ? 'selected' : ''
                  }`}
                  onClick={() => handleCurrencySelect(code)}
                >
                  <span className="currency-selector-mobile__symbol">{currency.symbol}</span>
                  <span className="currency-selector-mobile__name">{currency.name}</span>
                  <span className="currency-selector-mobile__code">({code})</span>
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default CurrencySelectorMobile;

